<script setup lang="ts"></script>

<template>
  <router-link to="/empresa/evento">Agregar Evento</router-link>
</template>

<style scoped></style>
